import chunk from 'lodash.chunk';
import {
    displayPercent,
    displayShortDate,
    DASH_DEFAULT
} from '../../utils/Format/Format';
import { /* getFundCategory, */ newFundUtil } from '../../utils/fund-info';
// import { FUND_TYPES } from '../../utils/constants';

export const EQUITY_ETFS = ['TCHP', 'TDVG', 'TEQI', 'TGRW', 'TSPA'];

export const topTenHoldingsUtil = (selectedPeriod, selectedDate) => (
    gqlResult
) => {
    if (!gqlResult) return null;

    const { name, inceptionDate, broadAssetClass, selectiveDisclosures } =
        gqlResult.mutualFund || gqlResult.exchangeTradedFund;

    const { quarterly = {}, monthly = [] } = selectiveDisclosures || {};

    let effectiveDates = monthly.map((ele) => ({
        value: ele.asOfDate,
        label: displayShortDate(ele.asOfDate),
        hasData: ele.individualHoldings && ele.individualHoldings.length > 0
    }));

    const fundAgeInMonth = newFundUtil(inceptionDate, 'months');
    if (fundAgeInMonth) {
        effectiveDates = effectiveDates.slice(0, 1);
    }

    let asOfDate = !selectedDate
        ? monthly[0] && monthly[0].asOfDate
        : selectedDate;
    asOfDate = selectedPeriod === 'month' ? asOfDate : quarterly.asOfDate;

    let selectiveDisclosure;
    if (selectedPeriod === 'month') {
        [selectiveDisclosure = {}] = monthly.filter(
            (ele) => ele.asOfDate === asOfDate
        );
    } else {
        selectiveDisclosure = quarterly;
    }

    // pick non-empty monthly data (shouldn't really happen)
    if (
        selectedPeriod === 'month' &&
        (!selectiveDisclosure.individualHoldings ||
            selectiveDisclosure.individualHoldings.length < 1)
    ) {
        [selectiveDisclosure] = monthly.filter(
            (ele) => ele.individualHoldings && ele.individualHoldings.length > 0
        );
        ({ asOfDate = '' } = !selectiveDisclosure || selectiveDisclosure);
    }

    const data =
        selectiveDisclosure && selectiveDisclosure.individualHoldings.length
            ? selectiveDisclosure.individualHoldings.map((ele) => ({
                  label: ele.name || DASH_DEFAULT,
                  values: [
                      {
                          val1:
                              (Boolean(ele.percentTotalNetAssets) &&
                                  displayPercent(ele.percentTotalNetAssets)) ||
                              DASH_DEFAULT
                      }
                  ]
              }))
            : [];

    const chunkedData = chunk(data, 5).map((d) => ({ data: d }));

    const buttonList = [
        { label: 'Monthly', val: 'month', disabled: false },
        {
            label: 'Quarterly',
            val: 'quarter',
            disabled:
                !quarterly ||
                !Object.keys(quarterly).length ||
                quarterly.rankings < 1
        }
    ];

    return {
        data: chunkedData,
        percent10LargestHoldings: displayPercent(
            !selectiveDisclosure ||
                selectiveDisclosure.top10CalculatedPercentage ||
                selectiveDisclosure.top10Percentage
        ),
        asOfDate,
        totalHoldings: selectiveDisclosure && selectiveDisclosure.totalHoldings,
        name,
        inceptionDate,
        effectiveDates,
        broadAssetClass,
        buttonList
    };
};

export const quarterlyTopTenHoldingsUtil = () => (gqlResult) => {
    if (!gqlResult) return null;

    const {
        name,
        inceptionDate,
        broadAssetClass,
        selectiveDisclosures
    } = gqlResult.exchangeTradedFund;

    const { quarterly = {} } = selectiveDisclosures || {};

    const asOfDate = quarterly && quarterly.asOfDate;
    const data =
        (quarterly &&
            quarterly.individualHoldings &&
            quarterly.individualHoldings.length &&
            quarterly.individualHoldings.map((ele) => ({
                label: ele.name || DASH_DEFAULT,
                values: [
                    {
                        val1:
                            (Boolean(ele.percentTotalNetAssets) &&
                                displayPercent(ele.percentTotalNetAssets)) ||
                            DASH_DEFAULT
                    }
                ]
            }))) ||
        [];

    const chunkedData = chunk(data, 5).map((d) => ({ data: d }));

    return {
        data: chunkedData,
        percent10LargestHoldings: displayPercent(
            quarterly.top10CalculatedPercentage || quarterly.top10Percentage
        ),
        asOfDate,
        totalHoldings: quarterly.totalHoldings,
        name,
        inceptionDate,
        broadAssetClass
    };
};
